import { useAppTranslation } from '@hooks/useAppTranslation';
import { routes } from '@navigation/routes';
import { useNavigate } from 'react-router';
import { Button } from 'common-components';
import { HitType } from '@pages/types';

import { tasklineHitViews } from '../type';

import { store } from '@/store';

type ReviewButtonProjectPropsType = {
  idProject: string
  hitReview: HitType
};

const ReviewButtonProject = ({ idProject, hitReview }: ReviewButtonProjectPropsType) => {
  const addErrorNotificationAction = store.use.addErrorNotificationAction();

  const { translate } = useAppTranslation();
  const navigate = useNavigate();

  const showError = () => {
    addErrorNotificationAction({
      description: translate('project.notifications.nextHitError'),
    });
  };

  const navigateToHit = () =>
    navigate(
      routes.projectTaskHit.navigate(
        idProject,
        hitReview?.task.idTask,
        `${tasklineHitViews[0]}/${hitReview?.idHit}`,
      ),
    );

  return (
    <>
      <Button
        size="sm"
        disabled={!idProject}
        onClick={hitReview?.task && hitReview?.idHit ? navigateToHit : showError}
      >
        {translate('project.navigation.review')}
      </Button>
    </>
  );
};

export default ReviewButtonProject;
